import styled from 'styled-components'

export const GoalStyled = styled.div`
    display: flex;
    align-items: center;
    border-radius: 0.5rem;
    background-color: #fff;
    align-items: stretch;
    padding: 1rem;

    i {
        font-size: 2.5rem;
        margin-right: 0.5rem;
        color: #1d3557;
    }

    p {
        font-size: 0.875rem;
    }
`
